import { ConfigEnv } from "@wwg/config-env";

const env = new ConfigEnv()
  .forDomain("localhost", {
    apiBase: "https://dev-api.wwg.support",
    dreamcastApiBase: "https://dev-api.wwg.support/v1/dreamcast",
    pageTitle: "DreamCast Admin - Local Dev",
    flags: {},
    externalLinks: [
      { name: "WWG Support - AU", href: "https://au.wwg.support/" },
      { name: "WWG Support - Legacy", href: "https://legacy.wwg.support" },
    ],
  })

  .forDomain("dev-dreamcast.wwg.support", {
    // DreamCast BFF via the APIM gateway; APIM mounts the API under
    // v1/dreamcast (per Bret), and the function routes carry no prefix.
    apiBase: "https://dev-api.wwg.support",
    dreamcastApiBase: "https://dev-api.wwg.support/v1/dreamcast",
    pageTitle: "DreamCast Admin - Dev",
    flags: {},
    externalLinks: [
      { name: "WWG Support - AU", href: "https://au.wwg.support/" },
      { name: "WWG Support - Legacy", href: "https://legacy.wwg.support" },
    ],
  })

  .forDomain("dreamcast-staging.wwg.support", {
    apiBase: "https://api-staging.wwg.support",
    dreamcastApiBase: "https://api-staging.wwg.support/v1/dreamcast",
    pageTitle: "DreamCast Admin - Staging",
    flags: {},
    externalLinks: [
      { name: "WWG Support - AU", href: "https://au.wwg.support/" },
      { name: "WWG Support - Legacy", href: "https://legacy.wwg.support" },
    ],
  })

  .forDomain("dreamcast.wwg.support", {
    apiBase: "https://api-ca.wwg.support",
    dreamcastApiBase: "https://api-ca.wwg.support/v1/dreamcast",
    pageTitle: "DreamCast Admin",
    flags: {},
    externalLinks: [
      { name: "WWG Support - AU", href: "https://au.wwg.support/" },
      { name: "WWG Support - Legacy", href: "https://legacy.wwg.support" },
    ],
  });

export default env.config;
